import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Element from 'element-ui'
import Cookies from 'js-cookie'

// Element UI 语言包
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'

// 你的语言包
import en from '@/lang/en'
import tw from '@/lang/zh-TW'
import cn from '@/lang/zh-CN'

Vue.use(VueI18n)

// 合并语言包
const messages = {
  'en': Object.assign({}, enLocale, en),
  'zh-CN': Object.assign({}, zhCNLocale, cn),
  'zh-TW': Object.assign({}, zhTWLocale, tw)
}

// 获取默认语言（优先读 Cookies）
function getDefaultLocale() {
  const saved = Cookies.get('LOCALE_LANGUAGES')
  if (saved && messages[saved]) return saved

  const browserLang = navigator.language
  if (messages[browserLang]) return browserLang

  return 'zh-TW'
}

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: 'zh-TW',
  messages
})

// 切换语言并持久化到 Cookies
export function setLocale(lang) {
  if (!messages[lang]) return
  i18n.locale = lang
  Cookies.set('LOCALE_LANGUAGES', lang, { expires: 7300 })
}

// 注册 Element UI
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

export default i18n